var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tag',{ref:"tag",style:(_vm.getStylesByTypeAndEffect(_vm.type, _vm.effect)),attrs:{"type":_vm.type,"size":_vm.size,"effect":_vm.effect,"closable":_vm.closable}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }